import { apiRequest } from './api';

// 笔记API服务
export const notesAPI = {
  // 创建笔记
  createNote: async (titleEncrypted, contentEncrypted, noteKeyEncrypted, userKeys) => {
    return await apiRequest('/api/v1/notes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title_encrypted: titleEncrypted,
        content_encrypted: contentEncrypted,
        note_key_encrypted: noteKeyEncrypted,
      }),
    }, userKeys);
  },

  // 获取笔记列表
  getNotes: async (page = 1, limit = 20, search = '', userKeys) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    return await apiRequest(`/api/v1/notes?${params.toString()}`, {
      method: 'GET',
    }, userKeys);
  },

  // 获取单个笔记
  getNote: async (noteId, userKeys) => {
    return await apiRequest(`/api/v1/notes/${noteId}`, {
      method: 'GET',
    }, userKeys);
  },

  // 更新笔记
  updateNote: async (noteId, titleEncrypted, contentEncrypted, noteKeyEncrypted, userKeys) => {
    return await apiRequest(`/api/v1/notes/${noteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title_encrypted: titleEncrypted,
        content_encrypted: contentEncrypted,
        note_key_encrypted: noteKeyEncrypted,
      }),
    }, userKeys);
  },

  // 删除笔记
  deleteNote: async (noteId, userKeys) => {
    return await apiRequest(`/api/v1/notes/${noteId}`, {
      method: 'DELETE',
    }, userKeys);
  },

  // 搜索笔记
  searchNotes: async (searchTerm, page = 1, limit = 20, userKeys) => {
    const params = new URLSearchParams({
      q: searchTerm,
      page: page.toString(),
      limit: limit.toString(),
    });

    return await apiRequest(`/api/v1/notes/search?${params.toString()}`, {
      method: 'GET',
    }, userKeys);
  },

  // 获取笔记统计
  getNoteStats: async (userKeys) => {
    return await apiRequest('/api/v1/notes/stats', {
      method: 'GET',
    }, userKeys);
  }
};
